import React from 'react'
import {
  Text,
  // @ts-ignore no types
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import {
  SealedBidStatusInfo,
  useGeneralizedSealedBidStatus,
} from 'common/containers/SealedBid/buildingBlocks'
import { useListingContext } from 'common/context/listing'
import { getServerTimeMoment } from 'common/modules/auctionCountdown'
// @ts-ignore no types
import styles from '../index.scss'

const cx = classnames.bind(styles)

const SealedBidStatusMessageBox = () => {
  const { listing, segment } = useListingContext()
  if (!segment) return null

  const { data } = useGeneralizedSealedBidStatus({ segment, listing })

  return (
    <div>
      <Text
        className={cx('align-left')}
        color='gray'
        weight='medium'
        data-elm-id='sealed_bid_status_info_label'
      >
        Status
      </Text>
      <SealedBidStatusInfo
        generalSealedBidData={data}
        currentServerDateTime={getServerTimeMoment(segment)}
      />
    </div>
  )
}

export default SealedBidStatusMessageBox
